import { CloseOutlined } from '@ant-design/icons'
import { Horizontal } from '@gravitate-js/excalibrr'
import { Tag } from 'antd'
import { type MetricFilters, hasMetricFilters } from '../metricFilters'

// A filter is worth reading at the size of the controls it sits beside, not at
// antd's 12px chip default.
const TAG_STYLE = { fontSize: 14, lineHeight: '22px', padding: '1px 10px' }
// antd's own close icon is a fixed 10px, which reads as a speck beside 14px
// text rather than as the thing that clears the filter.
const CLOSE_ICON = <CloseOutlined style={{ fontSize: 12 }} />

interface MetricFilterTagsProps {
  filters: MetricFilters
  onChange: (filters: MetricFilters) => void
}

/**
 * What the metric grids have narrowed the list to. The rows themselves toggle,
 * but a filter set from the other side of the page needs to be visible -- and
 * clearable -- from over here.
 */
export function MetricFilterTags({ filters, onChange }: MetricFilterTagsProps) {
  if (!hasMetricFilters(filters)) return null

  return (
    <Horizontal gap={4} verticalCenter style={{ flexWrap: 'wrap' }}>
      {filters.partner && (
        <Tag
          closable
          closeIcon={CLOSE_ICON}
          style={TAG_STYLE}
          onClose={() => onChange({ ...filters, partner: null })}
        >
          {`Partner: ${filters.partner.tenantName}`}
        </Tag>
      )}
      {filters.event && (
        <Tag
          closable
          closeIcon={CLOSE_ICON}
          style={TAG_STYLE}
          onClose={() => onChange({ ...filters, event: null })}
        >
          {`Event: ${filters.event}`}
        </Tag>
      )}
    </Horizontal>
  )
}
